import { useContext, useCallback } from 'react';
import { SortContext } from '../../utils/SortContext.js';

function useSort(id) {
  var context = useContext(SortContext);
  if (context === undefined) {
    throw new Error('useSort must be used within a provider');
  }
  var order = context.id === id ? context.order : null;
  var handleSort = useCallback(function (event) {
    if (context.onSort) {
      if (context.id !== id) {
        context.onSort(id, 'desc', event);
      } else {
        context.onSort(id, context.order === 'asc' ? 'desc' : 'asc', event);
      }
    }
  }, [id, context]);
  return {
    order: order,
    onSort: handleSort
  };
}

export { useSort };
